export default __webpack_public_path__ + "static/media/cleanproWelcomeLogo.6ebf20c8.png";